import { normalizeStoredAvatarUrl } from '@/lib/avatarPublic';

export async function getAgentSession() {
  const res = await fetch('/api/agent/session', { credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.ok) {
    return {
      ok: false,
      status: res.status,
      code: typeof data.code === 'string' ? data.code : '',
      error: typeof data.error === 'string' ? data.error : '',
      agentId: null,
      username: null,
      email: null,
      name: null,
      preferredTheme: 'dark',
      preferredLanguage: 'English (EN)',
      avatarUrl: '',
    };
  }
  const preferredTheme = data.preferredTheme === 'light' ? 'light' : 'dark';
  return {
    ok: true,
    agentId: typeof data.agentId === 'string' ? data.agentId : null,
    username: typeof data.username === 'string' ? data.username : null,
    email: typeof data.email === 'string' ? data.email : null,
    name: typeof data.name === 'string' ? data.name : '',
    preferredTheme,
    preferredLanguage:
      typeof data.preferredLanguage === 'string' && data.preferredLanguage.trim()
        ? data.preferredLanguage.trim()
        : 'English (EN)',
    avatarUrl:
      normalizeStoredAvatarUrl(typeof data.avatarUrl === 'string' ? data.avatarUrl : '') || '',
  };
}

export async function agentLogout() {
  await fetch('/api/agent/logout', { method: 'POST', credentials: 'include' });
}
